import "react-native-get-random-values";
import Constants from "expo-constants";
import React, { useContext } from "react";
import { StyleSheet, View } from "react-native";
import { GooglePlacesAutocomplete } from "react-native-google-places-autocomplete";
import Icon from "react-native-vector-icons/MaterialIcons";
import { AppContext } from "../context-provider/ContextProvider";

const GOOGLE_MAPS_API_KEY = Constants.expoConfig.extra.googleMapsApiKey;

const LocationInput = () => {
  const { appData, setAppdata } = useContext(AppContext);

  return (
      <View style={styles.innerContainer}>
        <GooglePlacesAutocomplete
          placeholder="Enter your home address"
          fetchDetails={true}
          onPress={(data, details = null) => {
            console.log("Selected Address:", data.description);
            setAppdata({ ...appData, address: data.description });
          }}
          query={{
            key: GOOGLE_MAPS_API_KEY,
            language: "en",
          }}
          styles={{
            textInput: styles.textInput,
            listView: styles.suggestionsList,
          }}
          renderLeftButton={() => (
            <Icon
              name="location-pin"
              size={24}
              color="#990000"
              style={styles.icon}
            />
          )}
        />
      </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexGrow: 1, // Makes sure the content stretches properly
    justifyContent: "center",
    backgroundColor: "#000",
  },
  innerContainer: {
    flexDirection: "row", // Align input and icon
    alignItems: "center",
    marginBottom: 50, // Position input box appropriately
  },
  textInput: {
    flex: 1,
    height: 50,
    borderColor: "gray",
    borderWidth: 1,
    borderRadius: 5,
    paddingLeft: 40,
    paddingRight: 10,
    fontSize: 16,
    color: "#000",
    backgroundColor: "#fff",
  },
  icon: {
    position: "absolute",
    zIndex: 10,
    left: 10,
    top: 13,
  },
  suggestionsList: {
    backgroundColor: "#fff",
    borderRadius: 5,
    elevation: 3,
    marginTop: 5,
  },
});

export default LocationInput;